import { combineReducers } from 'redux';

import { reducer as list } from './listModule';
import { reducer as restore } from './restoreModule';

export default combineReducers({
	list,
	restore,
});
